<script>
import { setPageTitle } from "../utils/helpers";
import prooflist from "../components/proof-archive/proof-list.vue";
import approverSettings from "../components/approver-item/approverSettings.vue";

export default {
  components: {
    approverSettings,
    prooflist,
  },
  data() {
    return {
      user: this.$A.Auth,
      editingApprover: null,
      steps: [
        {
          target: "#approver_information",
          content: `You can edit your contacts information here. If you’d like, you can also create automated proof reminders, too.`,
          params: {
            enableScrolling: false,
            placement: "top",
          },
        },
      ],
      tourCallbacks: {
        onStop: function () {
          window.$A.SaveCompletionOfProductTours("approver-item");
        },
      },
    };
  },
  mounted() {
    if (this.$A.viewToViewData && this.$A.viewToViewData.approver) {
      this.handleLoadedApprover(this.$A.viewToViewData.approver);
    }
    if (this.user.productTourState.indexOf("approver-item") === -1) {
      this.$tours["approverTour"].start();
    }
  },
  computed: {
    viewMode: function () {
      return this.editingApprover && this.editingApprover.totalProofs >= 1;
    },
  },
  methods: {
    handleLoadedApprover: function (approverWithStats) {
      this.editingApprover = approverWithStats;
      if (approverWithStats) setPageTitle(approverWithStats.name || approverWithStats.email || "Contact");
    },
  },
};
</script>

<template>
  <div>
    <navigation/>
    <div class="container-fluid nav-margin">
      <div class="experience-switch" v-show="editingApprover && editingApprover.id > 0">
        <span class="experience-pill">New</span>
        <span class="experience-text">We've redesigned the contact page.</span>
        <a
          :href="`/contact-details?id=${editingApprover && editingApprover.id}`"
          class="experience-link"
        >Try the new experience →</a>
      </div>
      <div class="row mt-50">
        <div class="col-md-12">
          <!-- Field -->
          <div class="field-item mb-50">
            <div class="row">
              <div class="col-md-12 mb-25">
                <h3 id="approver_information">Contact Information</h3>
              </div>
            </div>
            <approverSettings
                ref="editApproverInstance"
                v-on:approverCreated="handleLoadedApprover"
            />
            <div class="row">
              <div class="col-md-12 d-flex justify-content-end">
                <a data-cy="saveApproverBtn"
                   class="green-btn button"
                   @click="$refs.editApproverInstance.save()">Save</a>
              </div>
            </div>
          </div>
          <prooflist v-if="editingApprover && editingApprover.id" :approverId="editingApprover !== null ? editingApprover.id : null" :view-mode="viewMode" :contact-proof-view-mode="viewMode"/>
        </div>
      </div>
    </div>
    <modal
        name="deleteApproverModal"
        eventToEmitOnConfirmation="delete::approver::confirmed"
        question="Delete This Contact?"
        body="Are you sure you want to delete this contact? You cannot undo this action."
        confirm-button-text="Yes, Delete"
    />
    <v-tour
        name="approverTour"
        :steps="steps"
        :callbacks="tourCallbacks"
    ></v-tour>
  </div>
</template>

<style scoped>

.experience-switch {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 8px 16px;
  background: rgba(1, 146, 86, 0.06);
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  font-size: 13px;
  color: #4b5563;
}
.experience-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  background: #019256;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  border-radius: 999px;
  letter-spacing: 0.02em;
}
.experience-text { color: #4b5563; }
.experience-link {
  color: #019256;
  font-weight: 600;
  text-decoration: none;
}
.experience-link:hover { text-decoration: underline; color: #017a48; }

#approver_information {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
}

.green-btn {
  background: #019256;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #F9F9F9;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 130px;
  height: 38px;
}

@media screen and (max-width: 767px) {

  .green-btn {
    margin-bottom: 0px !important;
  }


}


</style>